import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../../ds';
import './ProcessingStep.scss';

const ProcessingStep = ({ currentStep, orderResponse, onNext, onClose }) => {
  return (
    <div className='processing-container'>
      <div className='processing-header'>
        <span onClick={onClose} className='processing-close-btn'>
          ×
        </span>
      </div>

      <h3 className='processing-title'>Procesando</h3>

      <div className='processing-content'>
        <p>Estado: {currentStep}</p>
        {orderResponse && (
          <div>
            <p>
              <strong>Processing Order:</strong> {orderResponse.data.order_id}
            </p>
          </div>
        )}
        <div className='processing-button'>
          <Button
            type='primary-alternate'
            onClick={() => onNext()}
            size='small'
          >
            Continuar
          </Button>
        </div>
      </div>
    </div>
  );
};

ProcessingStep.propTypes = {
  currentStep: PropTypes.string.isRequired,
  orderResponse: PropTypes.object,
  onNext: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ProcessingStep;
